// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"6c3fa7b0","273":"20a3147b","383":"3566e733","471":"4e8c83da","574":"20a3147b","583":"20a3147b","778":"20a3147b"}[chunkId] + ".chunk.css";
};